import axios from "axios";
import { API } from "../config";

const path = "/anexos";
const subPath = "/servico-acolhimento"

class AnexosSAService {
  novaAnexoSA(Anexo) {
    let formData = new FormData();

    for (let key in Anexo) {
      formData.append(key, Anexo[key]);
    }

    return axios.post(API + path, formData);
  }

  getAnexo(id, opcao) {
    return axios.get(API + path + `/${id}/${opcao}`)
  }

  listarAnexos(id) {
    return axios.get(API + path);
  }

  listarAnexosSA(id) {
    return axios.get(API + path + subPath + `/listar/${id}`);
  }
  listarCategorias(id) {
    return axios.get(API + path + `/lista/${id}`);
  }

}
const instanceAnexos = new AnexosSAService();
export default instanceAnexos;